import { segmentsTracking } from 'src/common/lib/tracker';
import { ModelCategory } from '../lib/interfaces';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30N9J = '30C9R';
export const COOKIE_ID = 'urxdcq';

export const defaultValues = (
  type: string,
  translation: TranslationFunction,
) => {
  if (type === 'steps')
    return [
      { value: 1, label: translation('modal_step_1', true) },
      { value: 2, label: translation('modal_step_2', true) },
      { value: 3, label: translation('modal_step_3', true) },
      { value: 4, label: translation('modal_step_4', true) },
      { value: 5, label: translation('modal_step_5', true) },
    ];
  else if (type === 'steps_secondary')
    return [
      { value: 1, label: translation('modal_step_1', true) },
      { value: 2, label: translation('modal_step_2', true) },
      { value: 3, label: translation('modal_step_3', true) },
      { value: 4, label: translation('modal_step_5', true) },
    ];
  else if (type === 'capacity')
    return [
      { id: 1, text: translation('capacity_opt1', true) },
      { id: 2, text: translation('capacity_opt2', true) },
      { id: 3, text: translation('capacity_opt3', true) },
      { id: 4, text: translation('capacity_opt4', true) },
      { id: 5, text: translation('capacity_opt5', true) },
      { id: 6, text: translation('capacity_opt6', true) },
      { id: 7, text: translation('capacity_opt7', true) },
    ];
  else if (type === 'connectivity')
    return [
      { id: 0, text: translation('connectivity_opt1', true) },
      { id: 1, text: translation('connectivity_host_opt1', true) },
      { id: 2, text: translation('connectivity_host_opt2', true) },
      { id: 3, text: translation('connectivity_host_opt3', true) },
      { id: 4, text: translation('connectivity_host_opt4', true) },
      { id: 5, text: translation('connectivity_host_opt5', true) },
    ];
  else if (type === 'connectivityVM')
    return [
      { id: 0, text: translation('connectivity_opt1', true) },
      { id: 1, text: translation('connectivity_vm_opt1', true) },
      { id: 2, text: translation('connectivity_vm_opt2', true) },
      { id: 3, text: translation('connectivity_vm_opt3', true) },
      { id: 4, text: translation('connectivity_vm_opt4', true) },
      { id: 5, text: translation('connectivity_vm_opt5', true) },
    ];
  else if (type === 'connectivitycopy')
    return [
      { id: 0, text: translation('connectivity_opt1', true) },
      { id: 1, text: translation('connectivity_copy_opt1', true) },
      { id: 2, text: translation('connectivity_copy_opt2', true) },
      { id: 3, text: translation('connectivity_copy_opt3', true) },
      { id: 4, text: translation('connectivity_copy_opt4', true) },
      { id: 5, text: translation('connectivity_copy_opt5', true) },
    ];
  else if (type === 'connectivitycopyVM')
    return [
      { id: 0, text: translation('connectivity_opt1', true) },
      { id: 1, text: translation('connectivity_copyVM_opt1', true) },
      { id: 2, text: translation('connectivity_copyVM_opt2', true) },
      { id: 3, text: translation('connectivity_copyVM_opt3', true) },
      { id: 4, text: translation('connectivity_copyVM_opt4', true) },
      { id: 5, text: translation('connectivity_copyVM_opt5', true) },
    ];
  else if (type === 'pdfPage1')
    return [
      translation('step2_right_h2', true),
      translation('step2_right_h3', true),
      translation('pdf_page1_option1', true),
      translation('pdf_page1_option2', true),
      translation('pdf_page1_option3', true),
      translation('pdf_page1_option4', true),
      translation('pdf_page1_option5', true),
    ];
  else if (type === 'solutionData')
    return [
      {
        label: translation('step1_accordion_dd2_pdf', true),
        isMultiple: true,
        value: [],
      },
      {
        label: translation('step4_accordion_dd1', true),
        isMultiple: false,
        value: '',
      },
      {
        label: translation('step4_accordion_dd2', true),
        isMultiple: false,
        value: '',
      },
      {
        label: translation('step4_accordion_dd3', true),
        isMultiple: false,
        value: '',
      },
      {
        label: translation('step4_accordion_dd4', true),
        isMultiple: false,
        value: '',
      },
      {
        label: translation('step3_accordion_title1', true),
        isMultiple: true,
        value: [],
      },
      {
        label: translation('step3_accordion_title2', true),
        isMultiple: true,
        value: [],
      },
      {
        label: translation('step2_accordion_title1', true),
        isMultiple: true,
        value: [],
      },
      {
        label: translation('step2_accordion_title2', true),
        isMultiple: true,
        value: [],
      },
      {
        label: translation('pdf_page4_title_opt10', true),
        isMultiple: true,
        value: [
          {
            url: 'https://community.ibm.com/community/user/storage/blogs/audrey-odonnell/2023/06/16/flashsystem-sustainability-guarantee',
            text: translation('pdf_page4_link_opt10', true),
          },
          translation('pdf_page4_para_opt10', true),
        ],
      },
      {
        label: translation('pdf_page4_title_opt11', true),
        isMultiple: true,
        value: [
          translation('pdf_page4_para1_opt11', true),
          translation('pdf_page4_para2_opt11', true),
        ],
      },
      {
        label: translation('pdf_page6_subTitle_1', true),
        isMultiple: true,
        value: [
          translation('pdf_page4_para1_opt12', true),
          translation('pdf_page4_para2_opt12', true),
          translation('pdf_page4_para3_opt12', true),
          translation('pdf_page4_para4_opt12', true),
          {
            url: 'https://www.ibm.com/flashsystem/storage-assurance',
            text: translation('pdf_page4_link_opt12', true),
          },
        ],
      },
    ];
  else if (type === 'businessContinuity')
    return [
      {
        value: 'snapshotManagement',
        text: translation('step2_business_opt_1', true),
      },
      { value: 'replication', text: translation('step2_business_opt_2', true) },
      {
        value: 'disasterRecovery',
        text: translation('step2_business_opt_3', true),
      },
      {
        value: 'highAvailability',
        text: translation('step2_business_opt_4', true),
      },
      {
        value: 'backupAndRecovery',
        text: translation('step2_business_opt_5', true),
      },
    ];
  else if (type === 'cyberResilience')
    return [
      {
        value: 'immutableCopies',
        text: translation('step2_cyber_opt_1', true),
      },
      { value: 'inlineThreat', text: translation('step2_cyber_opt_2', true) },
      { value: 'airGapped', text: translation('step2_cyber_opt_3', true) },
      {
        value: 'regulatoryRequirements',
        text: translation('step2_cyber_opt_4', true),
      },
      { value: 'cyberRecovery', text: translation('step2_cyber_opt_5', true) },
    ];
  else if (type === 'businessCyberResilience')
    return [
      {
        heading: translation('step2_right_h1', true),
        lists: [
          translation('step2_right_h1_l1', true),
          translation('step2_right_h1_l2', true),
        ],
      },
      {
        heading: translation('step2_right_h2', true),
        lists: [
          translation('step2_right_h2_l1', true),
          translation('step2_right_h2_l2', true),
          translation('step2_right_h2_l3', true),
          translation('step2_right_h2_l4', true),
          translation('step2_right_h2_l5', true),
        ],
      },
      {
        heading: translation('step2_right_h3', true),
        lists: [
          translation('step2_right_h3_l1', true),
          translation('step2_right_h3_l2', true),
          translation('step2_right_h3_l3', true),
          translation('step2_right_h3_l4', true),
          translation('step2_right_h3_l5', true),
        ],
      },
    ];
  else if (type === 'advancedConnectivity')
    return [
      {
        heading: translation('step3_right_h1', true),
        lists: [
          translation('step3_right_h1_l1', true),
          translation('step3_right_h1_l2', true),
        ],
      },
      {
        heading: translation('step3_right_h2', true),
        lists: [
          translation('step3_right_h2_l1', true),
          translation('step3_right_h2_l2', true),
          translation('step3_right_h2_l3', true),
          translation('step3_right_h2_l4', true),
          translation('step3_right_h2_l5', true),
        ],
      },
      {
        heading: translation('step3_right_h3', true),
        lists: [
          translation('step3_right_h3_l1', true),
          translation('step3_right_h3_l2', true),
          translation('step3_right_h3_l3', true),
          translation('step3_right_h3_l4', true),
          translation('step3_right_h3_l5', true),
        ],
      },
    ];
  else if (type === 'advancedItems')
    return [
      {
        value: 'flashTechnology',
        text: translation('step3_advanced_opt_1', true),
      },
      {
        value: 'hwCompression',
        text: translation('step3_advanced_opt_2', true),
      },
      {
        value: 'swDataReduction',
        text: translation('step3_advanced_opt_3', true),
      },
      {
        value: 'encryption',
        text: translation('step3_advanced_opt_4', true),
      },
      {
        value: 'transparentData',
        text: translation('step3_advanced_opt_5', true),
      },
    ];
  else if (type === 'connectivityItems')
    return [
      { value: 'iscsi', text: translation('step3_connect_opt_1', true) },
      { value: 'fiberChannel', text: translation('step3_connect_opt_2', true) },
      { value: 'nvme', text: translation('step3_connect_opt_3', true) },
      {
        value: 'vmware',
        text: translation('step3_connect_opt_4', true),
      },
      {
        value: 'partyPlatforms',
        text: translation('step3_connect_opt_5', true),
      },
    ];
  else return [];
};
/* Start of Modal Form data */
export const pageUrl = '/products/solution-advisor';
export const location = 'CRA Form';
// Must be the div id where you want the form to be loaded
export const INSTANCE_ID = 'urx-form';

// The required urx form-id to be embedded
export const FORM_ID = 'MAIL-storageflash';

// The required locale must be in the following format country code-language code
export const LOCALE = 'us-en';

export const SKELETON_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAEElEQVR42mN8+p+BgRFEAAAWrwPLzYNPyAAAAABJRU5ErkJggg==';

export const fileName = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const newDate = `${year}-${month}-${day} ${hours}_${minutes}`;
  return `Solution_Advisor_Report_${newDate}.pdf`;
};

export const selectOptions: ModelCategory[] = [
  {
    name: 'A',
    features: [
      'fiberChannel',
      'vmware',
      'partyPlatforms',
      'swDataReduction',
      'encryption',
    ],
  },
  {
    name: 'B',
    features: [
      'immutableCopies',
      'airGapped',
      'regulatoryRequirements',
      'cyberRecovery',
      'fiberChannel',
      'vmware',
      'partyPlatforms',
      'swDataReduction',
      'encryption',
    ],
  },
  {
    name: 'C',
    features: [
      'immutableCopies',
      'inlineThreat',
      'airGapped',
      'regulatoryRequirements',
      'cyberRecovery',
      'iscsi',
      'fiberChannel',
      'nvme',
      'vmware',
      'partyPlatforms',
      'hwCompression',
      'swDataReduction',
      'encryption',
    ],
  },
  {
    name: 'D',
    features: [
      'immutableCopies',
      'inlineThreat',
      'airGapped',
      'regulatoryRequirements',
      'cyberRecovery',
      'iscsi',
      'fiberChannel',
      'nvme',
      'vmware',
      'partyPlatforms',
      'hwCompression',
      'swDataReduction',
      'encryption',
    ],
  },
  {
    name: 'E',
    features: [
      'immutableCopies',
      'inlineThreat',
      'airGapped',
      'regulatoryRequirements',
      'cyberRecovery',
      'iscsi',
      'fiberChannel',
      'nvme',
      'vmware',
      'partyPlatforms',
      'hwCompression',
      'swDataReduction',
      'encryption',
    ],
  },
];

export const segmentsTrack = (evtName: string, location: string) =>
  segmentsTracking('CTA Clicked', {
    pageTitle: 'Solution Advisory',
    object: 'Solution Advisory Page',
    resultValue: 'CTA clicked',
    CTA: evtName,
    location,
    action: '',
    field: '',
  });

export const validLocales = [
  'ae-en',
  'ar-es',
  'at-de',
  'au-en',
  'ba-en',
  'be-en',
  'be-fr',
  'bg-en',
  'br-pt',
  'ca-en',
  'ca-fr',
  'ch-de',
  'ch-fr',
  'ch-it',
  'cl-es',
  'cn-zh',
  'co-es',
  'cz-en',
  'de-de',
  'dk-en',
  'ec-es',
  'eg-en',
  'es-es',
  'fi-en',
  'fr-fr',
  'hr-en',
  'hu-en',
  'id-en',
  'ie-en',
  'il-en',
  'in-en',
  'it-it',
  'jp-ja',
  'ke-en',
  'ma-fr',
  'mx-es',
  'my-en',
  'nl-en',
  'no-en',
  'nz-en',
  'pe-es',
  'ph-en',
  'qa-en',
  'ro-en',
  'sa-en',
  'se-en',
  'sg-en',
  'si-en',
  'sk-en',
  'th-en',
  'uk-en',
  'us-en',
  'vn-en',
  'za-en',
];
